import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { AirflowEntity, NamedAdapter } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AirflowEntity),
    adapts: {
        name: '*',
        properties: {
            description: '*',
            subType: '*',
            scope: '*',
            fileContent: '*'
        }
    }
})

export class AirflowEntityAdapter extends NamedAdapter<AirflowEntity, Model.AirflowEntityResource> {

    protected _toResource(airflowEntity: AirflowEntity): Model.AirflowEntityResource {
        const airflowEntityResource = super._toResource(airflowEntity) as Model.AirflowEntityResource;

        const modelProperties: Model.AirflowEntityProperties = {
            description: airflowEntity.description,
            subType: airflowEntity.subType,
            fileContent: airflowEntity.fileContent
        };

        if (airflowEntity.scope) {
            modelProperties.scope = airflowEntity.scope;
        }

        airflowEntityResource.properties = modelProperties;
        return airflowEntityResource;
    }

    protected _toModel(modelAirflowEntityResource: Model.AirflowEntityResource, airflowEntity?: AirflowEntity): AirflowEntity {
        if (!airflowEntity) {
            airflowEntity = AirflowEntity.MODEL.create<AirflowEntity>();
        }

        super._toModel(modelAirflowEntityResource, airflowEntity);

        const modelResourceProperties: Model.AirflowEntityProperties = modelAirflowEntityResource.properties as Model.AirflowEntityProperties;
        airflowEntity.description = modelResourceProperties.description;
        airflowEntity.subType = modelResourceProperties.subType;
        airflowEntity.fileContent = modelResourceProperties.fileContent;

        if (modelResourceProperties.scope) {
            airflowEntity.scope = modelResourceProperties.scope;
        }

        return airflowEntity;
    }
}
